<template>
<div class="container">
  <div class="con_wrap button">
    <div class="con_title">
      <img class="con_title_icon" src="../../../assets/images/evaluate/success.png">
      <div class="con_title_t">
        支付成功！
      </div>
    </div>
    <div class="con_time_title">离场剩余时间</div>
    <div class="con_time" v-if="countdownStr">{{countdownStr?countdownStr:'00:00:00'}}</div>
    <div class="con_tips">请在规定时间内取车，超时未驶离停车场需要补缴停车费</div>
    <div class="button" v-if="come != 'random'">
      <div class="con_btn btn_default" @click="back">
        知道了
      </div>
    </div>
  </div>
</div>
</template>

<script>
import util from '../../../utils/util';
import { freeCall} from '../../../utils/api'
export default {
  name: "success",
  data() {
    return {
      showBack: true,
      outEffectiveTime:'',
      maxtime:0,
      countdownStr:'',
      timeOut:"",
      timeInter:"",
      dataInfo:"",
      come:''
    }
  },
  created() {
    this.come = this.$route.query.random || ''
  },
  mounted(){
    let self = this;
    setTimeout(function () {
       self.fetchData();
    },3000)

    setTimeout(function () {
       self.fetchData();
    },6000)

    setTimeout(function () {
       self.fetchData();
    },9000)
  },
  beforeDestroy(){
    clearInterval(self.timeInter)
  },
  methods:{
    back() {
      let self = this;
      clearInterval(self.timeInter)
      this.$router.go(-2)
    },
    fetchData(){
      let self = this;
      let postInfo = {
        "plateNo":this.$route.query.plateNo,
        'url':'/parking/rstParkBill/getTimeoutLength'
      }
      // console.log('查询时间postInfo');
      // console.log(postInfo);
      freeCall(postInfo).then(res => {
        util.hideLoading();
        // console.log('查询时间3');
        // console.log(res);
        this.dataInfo = res
        if (res.res && res.res.code === 10000) {
          // console.log('查询时间');
          // console.log(res);
          self.$nextTick(() => {
            self.countdown(parseInt(res.body.data)) //结束时间到开始时间的时间差，单位秒
          })
        }
      })
    },
    countdown (sec) {
      let self = this;
      clearInterval(self.timeInter)
      self.timeOut = setTimeout(function () {
         let hour = 0
         let minute = 0
         let second = 0
          self.timeInter = setInterval(function () {
           if (sec >= 60) {
            minute = Math.floor(sec / 60)
            second = sec % 60
            if (minute >= 60) {
               hour = Math.floor(minute / 60)
               minute = minute % 60
             } else {
                  hour = 0
                }
           } else {
             second = sec
             hour = 0
             minute = 0
           }

           hour = parseInt(hour) < 10 && parseInt(hour) > 0 ? '0' + hour : hour
           minute = parseInt(minute) < 10 && parseInt(minute) > 0 ? '0' + minute : minute
           second = parseInt(second) < 10 && parseInt(second) > 0 ? '0' + second : second
           self.countdownStr = ' ' + (hour?hour:'00') + ':' + (minute?minute:'00') + ':' + (second?second:'00')
           // console.log('self.countdownStr')
           // console.log(self.countdownStr)
           sec--
           if (sec < 0) {
             // console.log('结束')
             clearInterval(self.timeInter);
           }
         }, 1000)
       }, 1000)
    }
  }
};
</script>

<style lang="less" scoped>
@import "../../../assets/css/common.less";
.con_wrap {
    display: flex;
    flex-direction: column;
    align-items: center;
}
.con_title {
    margin-bottom: 40px;
    margin-top: 120px;
    height: 66px;
    display: flex;
    align-items: center;
    .con_title_icon {
        width: 44px;
        height: 44px;
        margin: 12px 14px 10px;
    }
    .con_title_t {
        font-size: 48px;
        font-family: PingFangSC;
        font-weight: 500;
        color: rgba(51,51,51,1);
        line-height: 66px;

    }
}
.con_time_title {
    font-size: 28px;
    font-weight: 400;
    color: rgba(51,51,51,1);
    line-height: 40px;
    margin-bottom: 14px;
}
.con_time {
    font-size: 36px;
    font-weight: 400;
    color: rgba(252,63,86,1);
    line-height: 50px;
    margin-bottom: 40px;
}
.con_tips {
    width: 488px;
    height: 40px;
    font-size: 28px;
    font-family: PingFangSC;
    font-weight: 400;
    color: rgba(153,153,153,1);
    line-height: 40px;
    margin-bottom: 120px;
    text-align: center;
}
.con_btn {
    width: 332px;
    height: 76px;
    background: rgba(23,64,218,1);
    border-radius: 4px;
    text-align: center;
    line-height: 76px;
    font-size: 32px;
    font-family: PingFangSC;
    font-weight: 400;
    color: rgba(255,255,255,1);
}
</style>
